<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "StudentAttendance",
  data() {
    return {
      activeTab: "MyAttendance"
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
</style>
